import { render, staticRenderFns } from "./formPacienteSemLayout.vue?vue&type=template&id=1f27d29d"
import script from "./formPacienteSemLayout.vue?vue&type=script&lang=ts"
export * from "./formPacienteSemLayout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports